var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns",attrs:{"id":"back-button-container"}},[_c('div',{staticClass:"column"},[_c('a',{staticClass:"button",attrs:{"id":"back-button"},on:{"click":_vm.clickBtnBack}},[_vm._v("戻る")])])])}
var staticRenderFns = []

export { render, staticRenderFns }